import { motion } from "framer-motion";
import { reveal, VIEW_TIGHT } from "@/components/shared/motion";

export const fieldClass =
  "w-full rounded-xl border border-white/10 bg-[#0B0C10]/60 px-5 py-4 text-sm text-[#F4F6FB] placeholder:text-[#F4F6FB]/25 outline-none backdrop-blur-xl transition-colors duration-300 focus:border-[#8B5CF6]/60 focus-visible:ring-1 focus-visible:ring-[#8B5CF6]/40";

export const labelClass =
  "mb-2.5 block font-mono text-[10px] uppercase tracking-[0.28em] text-[#F4F6FB]/45";

export const Field = ({ label, hint, htmlFor, error, errorTestId, children }) => (
  <div>
    <label className={labelClass} htmlFor={htmlFor}>
      {label}
      {hint && <span className="ml-2 text-[#F4F6FB]/25">{hint}</span>}
    </label>
    {children}
    {error && (
      <p data-testid={errorTestId} className="mt-2 text-xs text-[#f87171]">
        {error}
      </p>
    )}
  </div>
);

export const Group = ({ id, title, children }) => (
  <motion.fieldset
    variants={reveal}
    initial="hidden"
    whileInView="show"
    viewport={VIEW_TIGHT}
    className="border-t border-white/10 pt-12"
  >
    <legend className="sr-only">{title}</legend>
    <div className="grid gap-10 md:grid-cols-[6rem_1fr] md:gap-12">
      <div>
        <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{id}</span>
        <p className="font-display mt-3 text-base font-semibold uppercase tracking-[0.12em] text-[#F4F6FB]">
          {title}
        </p>
      </div>
      <div className="space-y-7">{children}</div>
    </div>
  </motion.fieldset>
);
